import { defineStore } from "pinia";
import dayjs from "dayjs";
import { useCatalogsStore } from "@/stores/catalogs";

export const useMomentaryStore = defineStore("momentary", {
  state: () => ({
    isBusy: false,
    isBusy1: false,
    isShowSplash: false,
    isAPIError: false,
    APIErrorText: "",
    isOrdersBusy: false,
    isChartsByLegReady: true,
    isUKCReady: false,
    // Система загрузки данных
    loading: {
      // Критические загрузки (блокируют интерфейс)
      critical: {
        active: false,
        tasks: [], // массив объектов {key, label, progress}
      },
      // Фоновые загрузки (не блокируют интерфейс)
      background: {
        active: false,
        tasks: [], // массив объектов {key, label, progress}
      },
    },
    map: {
      // текущие координаты и зум карты
      lat: 60.1,
      lon: 24.9,
      zoom: 7,
    },
    route: {
      chartsbyroute: [],
      adpbyroute: [],
      enpbyroute: [],
      chartsbylegs: {}, // Изменили с массива на объект для хранения карт по номерам легов
      pubsbylegs: [],
      datasetbylegs: [],
    },
    charts: {
      listByRoute: [],
      cellsByRoute: [],
      graphByRoute: [],
    },
    graphs: {
      chartsGraph: [],
      shipImage: null,
      shipImageRequest: null,
      shipImageRequestOffset: 0,
    },
    // Информация о выбранном корабле (для использования на разных страницах)
    selectedShipInfo: {
      deviceId: null,
      shipData: null,      // объект корабля из fleet
      userData: null,      // объект пользователя с email
      agreementData: null, // объект договора
    },
    // Подписки на сервисы для выбранного корабля
    deviceSubscriptions: {
      // 'Navarea': true,
      // 'AIS-Around': true,
      // и т.д.
    },
  }),
  getters: {
    getShowSplashFlag: (state) => state.isShowSplash,
    isChartsByLegLoaded: (state) => state.route.isChartsByLegReady,
    isUKCLoaded: (state) => state.isUKCReady,
    getENPByRoute: (state) => state.route.enpbyroute,
    getADPByRoute: (state) => state.route.adpbyroute,
    getChartsByRoute: (state) => state.route.chartsbyroute,
    getChartsByLegs: (state) => state.route.chartsbylegs,

    getCellsByRoute: (state) => state.charts.cellsByRoute,
    getGraphByRoute: (state) => state.charts.graphByRoute,
    getListByRoute: (state) => state.charts.listByRoute,

    getChartsGraph: (state) => state.graphs.chartsGraph,

    getShipImage: (state) => state.graphs.shipImage,
    getShipImageRequest: (state) => state.graphs.shipImageRequest,
    getShipImageRequestOffset: (state) => state.graphs.shipImageRequestOffset,

    // Геттеры для системы загрузки
    isCriticalLoading: (state) => state.loading.critical.active,
    isBackgroundLoading: (state) => state.loading.background.active,
    criticalLoadingTasks: (state) => state.loading.critical.tasks,
    backgroundLoadingTasks: (state) => state.loading.background.tasks,
    currentCriticalTask: (state) =>
      state.loading.critical.tasks.length > 0
        ? state.loading.critical.tasks[0]
        : null,
    currentBackgroundTask: (state) =>
      state.loading.background.tasks.length > 0
        ? state.loading.background.tasks[0]
        : null,
    
    // Геттеры для информации о выбранном корабле
    getSelectedShipInfo: (state) => state.selectedShipInfo,
    getSelectedDeviceId: (state) => state.selectedShipInfo.deviceId,

    // Геттер для подписок на сервисы
    getDeviceSubscriptions: (state) => state.deviceSubscriptions,
    hasServiceSubscription: (state) => (serviceType) => {
      return state.deviceSubscriptions[serviceType] === true;
    },
  },
  actions: {
    setBusy(flag) {
      this.isBusy = flag;
    },
    setBusy1(flag) {
      this.isBusy1 = flag;
    },
    set2DImageRequest(val) {
      this.graphs.shipImageRequest = val;
    },
    set2DImageRequestoOffset(val) {
      this.graphs.shipImageRequestOffset = val;
    },
    setIsChartsByLegLoadedFlag(flag) {
      this.isChartsByLegReady = flag;
    },
    setShipImage(val) {
      try {
        // const bytes = new Uint8Array(val);
        // let binary = '';
        // for (let i = 0; i < bytes.byteLength; i++) {
        //     binary += String.fromCharCode(bytes[i]);
        // }
        // this.graphs.shipImage = 'data:image/png;base64,' + window.btoa(val);

        console.log("bbbb", typeof val);
        console.log("bbbb", val);

        if (typeof val === "string" && val.startsWith("/")) {
          val = val.substring(1);
        }

        const blob = new Blob(
          [new Uint8Array([...val].map((c) => c.charCodeAt(0)))],
          { type: "image/png" }
        );
        const reader = new FileReader();
        reader.onloadend = () => {
          this.graphs.shipImage = reader.result;
        };
        reader.readAsDataURL(blob);

        return;

        // Check if already a valid data URL
        if (
          typeof val === "string" &&
          val.startsWith("data:image/png;base64,i")
        ) {
          this.graphs.shipImage = val;
          return;
        }

        // For ArrayBuffer or binary data
        if (val instanceof ArrayBuffer) {
          const bytes = new Uint8Array(val);
          let binary = "";
          for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          this.graphs.shipImage =
            "data:image/png;base64," + window.btoa(binary).substring(1);
          return;
        }

        // Handle string that might be binary data or malformed base64
        if (typeof val === "string") {
          // If it starts with the incorrect slash character
          if (val.startsWith("/")) {
            // Remove the slash and add proper prefix
            this.graphs.shipImage = "data:image/png;base64," + val.substring(1);
            return;
          }

          // If it's raw binary data with PNG header
          if (val.indexOf("PNG") > -1) {
            const blob = new Blob(
              [new Uint8Array([...val].map((c) => c.charCodeAt(0)))],
              { type: "image/png" }
            );
            const reader = new FileReader();
            reader.onloadend = () => {
              this.graphs.shipImage = reader.result;
            };
            reader.readAsDataURL(blob);
            return;
          }

          // Regular base64 string without prefix
          this.graphs.shipImage = "data:image/png;base64," + val;
        }
      } catch (error) {
        console.error("Error processing image:", error);
      }
    },
    setCellsByRoute(val) {
      this.charts.cellsByRoute = val;
    },
    setChartsGraph(val) {
      this.graphs.chartsGraph = val;
    },
    setAPIError(flag, text = "") {
      this.isAPIError = flag;
      if (text) this.APIErrorText = " (" + text + ")";
      else this.APIErrorText = "";
    },
    setOrdersBusy(flag) {
      this.isOrdersBusy = flag;
    },
    addChartsByRoute(val) {
      this.route.chartsbyroute = val;
    },
    appendChartsByRoute(val) {
      this.route.chartsbyroute.push(val);
    },
    appendCellsByRoute(val) {
      this.charts.cellsByRoute.push(val);
    },
    addADPByRoute(val) {
      this.route.adpbyroute = val;
      // val["1"].forEach(item => {
      //     this.route.adpbyroute.push({id: item, disabled: false})
      // })
    },
    addENPByRoute(val) {
      this.route.enpbyroute = val;
      // val["1"].forEach(item => {
      //     this.route.enpbyroute.push({id: item, disabled: false})
      // })
    },
    // addAllPublications() {
    //     let catalogsStore = useCatalogsStore()
    //
    //     catalogsStore.getENP.products.forEach(item => {
    //         this.route.enpbyroute.push({id: item.id, title: item.title, disabled: true})
    //     })
    //     catalogsStore.getADP1.products.forEach(item => {
    //         this.route.adpbyroute.push({id: item.id, title: item.title, disabled: true})
    //     })
    //     catalogsStore.getADP2.products.forEach(item => {
    //         this.route.adpbyroute.push({id: item.id, title: item.title, disabled: true})
    //     })
    //     catalogsStore.getADP3.products.forEach(item => {
    //         this.route.adpbyroute.push({id: item.id, title: item.title, disabled: true})
    //     })
    // },
    addChartsByLegs(val) {
      this.route.chartsbylegs = val;
      this.isChartsByLegLoaded = true;
    },
    addDatasetByLegs(val) {
      this.route.datasetbylegs = val;
      this.isChartsByLegLoaded = true;
    },
    setShowSplashFlag(flag) {
      this.isShowSplash = flag;
    },
    setUKCLoadedFlag(flag) {
      // alert(flag)
      this.isUKCReady = flag;
    },
    addPubsByLegs(val) {
      this.route.pubsbylegs = val;
    },
    clearChartsByRoute() {
      this.route.chartsbyroute = [];
    },
    clearChartsByLegs() {
      this.route.chartsbylegs = {}; // Очищаем объект
      this.route.datasetbylegs = [];
    },

    // Сохранение состояния карты
    saveMapState(lat, lon, zoom) {
      this.map.lat = lat;
      this.map.lon = lon;
      this.map.zoom = zoom;
    },

    // Получение состояния карты
    getMapState() {
      return {
        lat: this.map.lat,
        lon: this.map.lon,
        zoom: this.map.zoom,
      };
    },

    // Проверка наличия состояния карты (для переключения между страницами)
    // hasMapState() {
    //   return this.map.lat !== 0 || this.map.lon !== 0 || this.map.zoom !== 0;
    // },

    // Сброс состояния карты
    resetMapState() {
      this.map.lat = 60.1;
      this.map.lon = 24.9;
      this.map.zoom = 7;
    },

    // Методы для управления критическими загрузками
    startCriticalLoading(key, label, progress = 0) {
      // Проверяем, есть ли уже такая задача
      const existingTaskIndex = this.loading.critical.tasks.findIndex(
        (task) => task.key === key
      );

      if (existingTaskIndex >= 0) {
        // Обновляем существующую задачу
        this.loading.critical.tasks[existingTaskIndex] = {
          key,
          label,
          progress,
        };
      } else {
        // Добавляем новую задачу
        this.loading.critical.tasks.push({ key, label, progress });
      }

      this.loading.critical.active = true;
    },

    updateCriticalLoading(key, progress, label = null) {
      const taskIndex = this.loading.critical.tasks.findIndex(
        (task) => task.key === key
      );
      if (taskIndex >= 0) {
        this.loading.critical.tasks[taskIndex].progress = progress;
        if (label) {
          this.loading.critical.tasks[taskIndex].label = label;
        }
      }
    },

    stopCriticalLoading(key) {
      const taskIndex = this.loading.critical.tasks.findIndex(
        (task) => task.key === key
      );
      if (taskIndex >= 0) {
        this.loading.critical.tasks.splice(taskIndex, 1);
      }

      if (this.loading.critical.tasks.length === 0) {
        this.loading.critical.active = false;
      }
    },

    // Методы для управления фоновыми загрузками
    startBackgroundLoading(key, label, progress = 0) {
      // return
      // Проверяем, есть ли уже такая задача
      const existingTaskIndex = this.loading.background.tasks.findIndex(
        (task) => task.key === key
      );

      if (existingTaskIndex >= 0) {
        // Обновляем существующую задачу
        this.loading.background.tasks[existingTaskIndex] = {
          key,
          label,
          progress,
        };
      } else {
        // Добавляем новую задачу
        this.loading.background.tasks.push({ key, label, progress });
      }

      this.loading.background.active = true;
    },

    updateBackgroundLoading(key, progress, label = null) {
      const taskIndex = this.loading.background.tasks.findIndex(
        (task) => task.key === key
      );
      if (taskIndex >= 0) {
        this.loading.background.tasks[taskIndex].progress = progress;
        if (label) {
          this.loading.background.tasks[taskIndex].label = label;
        }
      }
    },

    stopBackgroundLoading(key) {
      const taskIndex = this.loading.background.tasks.findIndex(
        (task) => task.key === key
      );
      if (taskIndex >= 0) {
        this.loading.background.tasks.splice(taskIndex, 1);
      }

      if (this.loading.background.tasks.length === 0) {
        this.loading.background.active = false;
      }
    },

    // Сброс всех состояний загрузки
    clearAllLoading() {
      this.loading.critical.tasks = [];
      this.loading.critical.active = false;
      this.loading.background.tasks = [];
      this.loading.background.active = false;
    },

    // Сохраняем информацию о выбранном корабле
    setSelectedShipInfo(deviceId, shipData, userData, agreementData) {
      this.selectedShipInfo = {
        deviceId,
        shipData,
        userData,
        agreementData,
      };
    },

    // Очищаем информацию о корабле
    clearSelectedShipInfo() {
      this.selectedShipInfo = {
        deviceId: null,
        shipData: null,
        userData: null,
        agreementData: null,
      };
    },

    // Сохраняем подписки на сервисы
    setDeviceSubscriptions(subscriptions) {
      this.deviceSubscriptions = subscriptions || {};
    },

    // Очищаем подписки
    clearDeviceSubscriptions() {
      this.deviceSubscriptions = {};
    },
  },
  persist: false,
});
